import {Leads, ListItemBase, Text, Trails, Typography} from '@yandex-delivery/blocks'
import React, {useMemo} from 'react'
import type {PollsHeader} from 'src/api/types'
import {tagToUrl} from 'src/shared/utils'

import {classes} from './Header.classes'

type Props = {
  header: PollsHeader
  isPollCompleted: boolean
}

export function Header({header, isPollCompleted}: Props): React.ReactElement<Props> {
  const {leadIcon, text, trailIcon} = useMemo(() => {
    if (isPollCompleted) {
      return {
        text: header.title_completed,
        trailIcon: header.completed_emoji_image_tag,
      }
    }
    return {
      leadIcon: header.image_tag,
      text: header.title_default,
    }
  }, [header, isPollCompleted])
  return (
    <ListItemBase size={leadIcon ? 'l' : 'm'}>
      {leadIcon && (
        <Leads.Icon>
          <img alt="" className={classes.leadIcon} data-theme-invert loading="lazy" src={tagToUrl(leadIcon)} />
        </Leads.Icon>
      )}
      <Text>
        <Typography group="tight" thickness="medium" variant="body1">
          {text}
        </Typography>
      </Text>
      {trailIcon && (
        <Trails.Icon>
          <img alt="" className={classes.trailIcon} data-theme-invert loading="lazy" src={tagToUrl(trailIcon)} />
        </Trails.Icon>
      )}
    </ListItemBase>
  )
}
